export const iconFontAwesomeTravelHotelWheelchairMove = (
	<i className="fa-solid fa-wheelchair-move"></i>
);
